import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';

const { FiCalendar, FiClock, FiMessageCircle } = FiIcons;

export const Reservation = () => {
  return (
    <section id="reservation" className="py-28 md:py-48 bg-cream/30 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gold/20" />
      <div className="container mx-auto px-6 md:px-14 max-w-4xl">
        <FadeIn className="text-center">
          <SectionLabel>Reservations</SectionLabel>
          <h2 className="font-serif text-4xl md:text-6xl text-charcoal mb-8 italic">Join Us for Dining</h2>
          <div className="w-16 h-px bg-gold mx-auto mb-12" />
          
          <div className="max-w-2xl mx-auto space-y-8">
            <p className="text-charcoal/60 font-light text-lg md:text-xl leading-relaxed italic">
              "We invite you to our bistro sanctuary on Amoy Street — where every table tells a story and every meal is an occasion."
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-12">
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center mb-2">
                  <SafeIcon icon={FiCalendar} className="text-gold" />
                </div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-charcoal/40 font-medium">Availability</p>
                <p className="text-charcoal font-serif text-lg">Daily Bookings</p>
              </div>
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center mb-2">
                  <SafeIcon icon={FiClock} className="text-gold" />
                </div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-charcoal/40 font-medium">Service</p>
                <p className="text-charcoal font-serif text-lg">Lunch & Dinner</p>
              </div>
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center mb-2">
                  <SafeIcon icon={FiMessageCircle} className="text-gold" />
                </div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-charcoal/40 font-medium">Hotline</p>
                <p className="text-charcoal font-serif text-lg">+65 8765 5023</p>
              </div>
            </div>

            <div className="pt-16 flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link 
                to="/reservations"
                className="inline-block px-12 py-4 bg-charcoal text-white text-xs tracking-[0.25em] uppercase hover:bg-wine transition-all duration-500"
              >
                Book Online
              </Link>
              <a 
                href="https://wa.me/6587655023"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-12 py-4 border border-gold text-gold text-xs tracking-[0.25em] uppercase hover:bg-gold hover:text-white transition-all duration-500"
              >
                WhatsApp Us
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gold/20" />
    </section>
  );
};